import React from 'react';
import { Element } from 'react-scroll';
import SectionTitle2 from '../../sectionTitle/SectionTitle2';

const advantages = [
  {
    title: "Vessel Operators",
    description: "Upgrade legacy systems with AI-powered performance and safety enhancements without full retrofits.",
  },
  {
    title: "Marine Energy Innovators",
    description: "Deploy Edge AI for energy optimization, asset control, and real-time analytics on offshore platforms.",
  },
  {
    title: "Coastal Authorities",
    description: "Use AI for emissions tracking, environmental monitoring, and smart navigation in ports and harbors.",
  },
  {
    title: "Aquaculture & Fisheries",
    description: "Integrate computer vision and sensors for fish health, feeding control, and sustainability monitoring.",
  },
  {
    title: "Maritime IoT & Sensor Vendors",
    description: "Extend your solutions with embedded AI for local decision-making and multi-sensor fusion.",
  },
  {
    title: "Research & Ocean Tech Institutions",
    description: "Use our platform for pilot testing, data analysis, and validation of intelligent marine systems.",
  },
]

const Advantage = () => {
  return (
    <>
      <Element
        name="Advantage"
        className="datatalent-section-gap solutions-advantage"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center text-white"
                title = "Maritime Ecosystem Integration"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center color-white">Seamless AI + IoT Integration Across the Blue Economy.</p>
            </div>
            {advantages.map((adv) =>
              <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5" key={adv.title}>
                <div className="advantage-card p-4 h-100">
                  <h5 className="mt-3 mb-3 color-white">{adv.title}</h5>
                  <p className="mb-3">{adv.description}</p>
                </div>
            </div>
            )}
          </div>
        </div>
      </Element>
    </>
  )
}

export default Advantage;